import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppHeader } from '../AppHeader';
import Sidebar from './sidebar';

export const HeaderAndSidebar = () => {
  return (
    <Sidebar>
      <AppHeader />
      <Outlet />
    </Sidebar>
  );
};
